/**
 * @file Web Galleries access request view.
 */
import React from 'react';

import ContentWrap from '../../../components/global/ContentWrap';
import WebGalleryAccessRequestFormContainer from '../containers/WebGalleryAccessRequestFormContainer';

const WebGalleryAccessRequestView = () => (
  <div className="wrapper-main content-wrap-gray">
    <div className="flex-auto">
      <ContentWrap size="md">
        <WebGalleryAccessRequestFormContainer />
      </ContentWrap>
    </div>
  </div>
);

export default WebGalleryAccessRequestView;
